// src/sponsorDefaults.js
//
// スポンサー機能で使う初期値。
//
// 【なぜ別ファイルにしているか】
//   同じ文言を SponsorsPage / SponsorApplyForm / SponsorSettingsEditor の
//   3ファイルが参照する。それぞれに書くと、片方だけ直したときに
//   「管理画面で見えている初期値」と「実際の表示」がズレる。
//   utils.js に入れないのは、あちらが index.js と意図的な二重実装を
//   持つファイルで、性質が違うため。
//
// 【注意】
//   ここに書いてあるのは「管理画面でまだ設定していないときに使う値」。
//   settings/sponsors に保存された値があれば、そちらが優先される。

export const DEFAULT_SPONSOR_CATEGORIES = [
    { id: 'health',  label: '整骨院・治療院',     order: 1 },
    { id: 'food',    label: '飲食店',             order: 2 },
    { id: 'fitness', label: 'ジム・フィットネス', order: 3 },
    { id: 'shop',    label: '物販・サービス',     order: 4 },
    { id: 'other',   label: 'その他',             order: 9 },
];

// 紹介者に付与するRBコインの既定額（管理画面で変更可）
export const DEFAULT_REWARD_AMOUNT = 1000;

export const DEFAULT_SPONSOR_TEXTS = {
    // 特典一覧ページ上部のバナー
    noticeText:    'Revengers FC の提携先です。会計時にクーポン画面をご提示ください。',
    noticeCaution: '※スクリーンショットは無効です。必ずこのアプリの画面をご提示ください。',

    // 申込ページの説明
    applyIntro:    'Revengers FC アプリの「提携パートナー」欄に、貴社の情報とクーポンを掲載いたします。',
    applyDetails:  '掲載期間: 1年間\n掲載料: 年額 10,000円（銀行振込）\n会員数: 約{memberCountRound}名（社会人サッカークラブ）',
    applyCautions: '※ 内容によっては掲載をお断りする場合がございます。\n※ 金融商品・アダルト・宗教・連鎖販売取引に関する掲載はお受けできません。',

    // 申込ページの「掲載イメージ」欄。どこに出るかの説明。
    applyPlacement: '・特典一覧ページ（会員が特典を探す専用ページ）\n・ホーム画面（予定表の下）\n・ランキング画面\n・ガチャの結果画面\n・マイページ\n\n※特典一覧ページ以外は、掲載中の企業さまから1社ずつランダムで表示されます。',
};

// 会員数の取得に失敗したときに使う値。
//   通信エラーで文章が壊れるより、おおよその数字を出したほうが実害が小さい。
//   実際の人数から大きく離れたら、この値も更新すること。
export const FALLBACK_MEMBER_COUNT = 600;

// 文章中の差し込み記号を実際の値に置き換える。
//   {memberCount}      … 実数（例: 609）
//   {memberCountRound} … 10の位で切り捨て（例: 600）「約〜名」と書くとき用
export const applyPlaceholders = (text, count) => {
    if (typeof text !== 'string') return text;
    const n = (typeof count === 'number' && count > 0) ? count : FALLBACK_MEMBER_COUNT;
    const rounded = Math.max(10, Math.floor(n / 10) * 10);
    return text
        .replace(/\{memberCountRound\}/g, String(rounded))
        .replace(/\{memberCount\}/g, String(n));
};

// 保存済みの値と既定値をマージする。
//   空文字も「意図的に空にした」とみなさず既定値へ戻す、という判断はしない。
//   （管理者が消したいケースがあるため、undefined / null のときだけ既定値を使う）
export const mergeTexts = (saved) => {
    const out = { ...DEFAULT_SPONSOR_TEXTS };
    if (saved && typeof saved === 'object') {
        Object.keys(DEFAULT_SPONSOR_TEXTS).forEach(k => {
            if (saved[k] !== undefined && saved[k] !== null) out[k] = saved[k];
        });
    }
    return out;
};